import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router";
import { AppContext } from "../AppContext";
import centroConocimiento from "../assets/img/centro-conocimiento.png";

const Header: React.FC = () => {
  const location = useLocation();
  const context = useContext(AppContext);
  const [typingTimer, setTypingTimer] = useState(0);
  const [placeholderText] = useState("¿Qué necesitas aprender hoy? (Ej: Gestión de notas, Matrículas...)");
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const mobileSearchInputRef = useRef<HTMLInputElement | null>(null);
  const isSoporte = context?.data.isSoporte || false;
  const isMobileAsideOpen = context?.isMobileAsideOpen || false;
  const hash = localStorage.getItem("hash") || "";

  const navigate = useNavigate();

  useEffect(() => {
    if (!mobileSearchOpen) {
      return;
    }

    window.setTimeout(() => {
      mobileSearchInputRef.current?.focus();
    }, 0);
  }, [mobileSearchOpen]);

  const sanitizeSearchTerm = (termino: string) => {
    console.log("Término original:", termino);
    return termino.toLowerCase().trim().replace(/\s+/g, "-");
  };

  const buscar = (termino: string) => {
    clearTimeout(typingTimer);
    setTimeout(() => {
      const normalizedTerm = sanitizeSearchTerm(termino);
      setSearchValue(normalizedTerm); // Actualizamos el estado con el término sin normalizar para que el usuario vea lo que escribió
      if (normalizedTerm !== "") {
        navigate(`/buscador/${normalizedTerm}`);
      } else {
        navigate(`/home/${hash}`);
      }
    }, 500)
  };

  const closeMobileSearch = () => {
    setMobileSearchOpen(false);
    setSearchValue("");

    if (location.pathname.includes('/link/')) return;

    navigate(`/home/${hash}`);
  };

  return (
    <header className="bg-pegasus fixed z-50 top-0 border-b border-outline-variant flex justify-between items-center w-full px-2  py-2">
      <div className="flex items-center gap-0">
        {!mobileSearchOpen && (
          <Link to={`/home/${hash}`} className="flex items-center hover:opacity-80 transition-opacity mr-0">
            <img src={centroConocimiento} alt="Pegasus" className="h-12 md:h-12 w-28 object-contain" />
          </Link>
        )}
        {/* <div className="hidden lg:flex items-center gap-2 pl-4 border-l-2 border-outline-variant">
          {isMobile ? (
            <span className="flex items-center gap-2 text-label-md font-label-md text-on-surface-variant bg-surface-container py-1 px-3 rounded-full">
              <span className="material-symbols-outlined text-sm">smartphone</span>
              APP MÓVIL ACADÉMICA
            </span>
          ) : (
            <a href="https://colpegasus.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-label-md font-label-md text-on-surface-variant hover:opacity-80 transition-opacity  no-underline">
              <img src={academica} alt="Académica" className="h-8 md:h-8 object-contain" />
            </a>
          )}
        </div> */}
      </div>
      <div className="flex items-center gap-4">
        <>
          <div className="hidden md:flex w-full mdflex items-center bg-surface-container-low px-4 py-2 border-2 border-transparent focus-within:border-primary transition-all rounded-3xl">
            <span className="material-symbols-outlined text-on-surface-variant">search</span>
            <input
              className="bg-transparent border-none focus:ring-0 focus:outline-none text-body-md font-body-md text-on-surface placeholder:text-on-surface-variant w-64 ml-2"
              placeholder={placeholderText}
              type="text"
              onChange={(event) =>
                buscar(event.target.value)
              }
            />

          </div>
          {isSoporte && (
            <Link
              to="/admin/secciones"
              className="material-symbols-outlined text-white hover:bg-surface-container hover:text-primary transition-colors p-2 rounded-full no-underline hidden md:flex"
              title="Administrar"
            >
              settings
            </Link>
          )}
          <div className="flex items-center gap-2 md:hidden">
            <div className="flex items-center gap-2 relative">
              <button
                className="material-symbols-outlined text-white hover:bg-surface-container transition-colors p-2 rounded-3xl"
                title="Buscar"
                onClick={() => setMobileSearchOpen((open) => !open)}
              >
                search
              </button>

              <div
                className={`absolute right-12 top-1/2 -translate-y-1/2 flex items-center overflow-hidden rounded-3xl border border-outline-variant bg-surface-container-low shadow-lg transition-all duration-300 ease-out md:hidden ${mobileSearchOpen ? "w-[20rem] opacity-100 translate-x-0 px-4 py-1" : "w-0 opacity-0 translate-x-3 px-0 py-1 border-transparent pointer-events-none"}`}
                aria-hidden={!mobileSearchOpen}
              >
                <span className="material-symbols-outlined text-on-surface-variant shrink-0">search</span>
                <input
                  ref={mobileSearchInputRef}
                  className="min-w-0 flex-1 bg-transparent border-none focus:ring-0 focus:outline-none text-body-md font-body-md text-on-surface placeholder:text-on-surface-variant ml-2"
                  placeholder={placeholderText}
                  type="text"
                  value={searchValue}
                  onChange={(event) => {
                    const value = event.target.value;
                    setSearchValue(value);
                    buscar(value);
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Escape") {
                      closeMobileSearch();
                    }
                  }}
                />
                <button
                  className="material-symbols-outlined text-on-surface-variant hover:text-on-surface transition-colors p-1 rounded-full shrink-0 ml-1"
                  title="Cerrar"
                  onClick={closeMobileSearch}
                  type="button"
                >
                  close
                </button>
              </div>
              {isSoporte && (
                <Link
                  to="/admin/secciones"
                  className="material-symbols-outlined text-white hover:bg-surface-container transition-colors p-2 rounded-full no-underline"
                  title="Administrar"
                >
                  settings
                </Link>
              )}
              <button
                className="material-symbols-outlined text-white hover:bg-surface-container transition-colors p-2 rounded-full"
                title="menu"
                onClick={() => context?.setMobileAsideOpen(!isMobileAsideOpen)}
              >
                menu
              </button>

            </div>

            {/* <button className="material-symbols-outlined text-white hover:bg-surface-container transition-colors p-2 rounded-full" title="Ayuda">help</button>
          <button className="material-symbols-outlined text-white hover:bg-surface-container transition-colors p-2 rounded-full" title="Notificaciones">notifications</button>
          {isSoporte && (
            <Link
              to="/admin/secciones"
              className="material-symbols-outlined text-white hover:bg-surface-container transition-colors p-2 rounded-full no-underline"
              title="Administrar"
            >
              settings
            </Link>
          )}
          <div className="w-10 h-10 rounded-full bg-surface-container-high overflow-hidden border border-outline-variant flex items-center justify-center">
            <span className="material-symbols-outlined text-primary">person</span>
          </div> */}
          </div>
        </>

      </div>
    </header>
  );
};

export default Header;